<div class="modal-header">
  <h5 class="modal-title">
    <i class="fal fa-share-alt"></i><ng-container>&nbsp;</ng-container
    ><ng-container i18n>Add Email Forwarding</ng-container>
  </h5>
  <button (click)="close()" type="button" class="close">
    <i class="far fa-times"></i>
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="form">
    <div class="row">
      <!-- Rentals -->
      <div class="col-sm-12">
        <app-rental-select
          [ctrl]="form.get('rentals')"
          i18n-placeholder
          placeholder="Select Rental(s)"
        ></app-rental-select>
      </div>
    </div>
    <div class="row">
      <!-- Title -->
      <div class="col-sm-12">
        <mat-form-field2 class="mat-block">
          <input
            type="text"
            matInput
            required
            i18n-placeholder
            placeholder="Forward (email or url)"
            formControlName="forward"
          />
          <mat-error *ngIf="forwardField.touched && forwardField.hasError('required')">
            <ng-container i18n>Forward is required</ng-container>
          </mat-error>
          <mat-error *ngIf="forwardField.touched && forwardField.hasError('emailOrUrl')">
            <ng-container i18n>Forward should be URL or Email</ng-container>
          </mat-error>
        </mat-form-field2>
      </div>
    </div>

    <div class="alert alert-secondary-info">
      <div class="alert-content" i18n>
        Please select a rental whose emails you would like to forward then enter a forwarding email address or URL.
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button (click)="close()" type="button" class="btn btn-light">
    <i class="far fa-times"></i> <ng-container i18n>Cancel</ng-container>
  </button>
  <button (click)="create(form)" type="button" class="btn btn-secondary-info create-btn">
    <i class="far fa-plus"></i> <ng-container i18n>create</ng-container>
  </button>
</div>
